module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cEu1a"))).then(() => module.bundle.root('d0iPb'));